import { Component, inject, input, signal, viewChild } from '@angular/core';
import { FormComponent, UiComponentsModule } from '@mwe/ui/components';
import { NgClass } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IPopupModelV2, ModalChild } from '@mwe/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UmmeldungWizardService } from '../../ummeldung.wizard.service';
import { UMMELDUNG_EXIT_POPUP_RESULT } from '../../utils';

@Component({
  selector: 'ikp-verify-save-ummeldung-popup',
  standalone: true,
  imports: [UiComponentsModule, ReactiveFormsModule, NgClass],
  templateUrl: './ummeldung-save-popup.component.html',
})
export class UmmeldungSavePopupComponent implements ModalChild {
  formComponent = viewChild(FormComponent);
  popupModel = signal<IPopupModelV2>(null);
  size = input<'small' | 'large'>('large');

  private readonly activeModal = inject(NgbActiveModal);
  private readonly ummeldungWizard = inject(UmmeldungWizardService);

  submit(): void {
    this.ummeldungWizard.trySaveDraft()?.subscribe(() => this.activeModal.close(UMMELDUNG_EXIT_POPUP_RESULT.saveAndExit));
  }

  closeWithoutSaving(): void {
    this.activeModal.close(UMMELDUNG_EXIT_POPUP_RESULT.discardAndExit);
  }

  cancelPopup(): void {
    this.activeModal.dismiss(UMMELDUNG_EXIT_POPUP_RESULT.stay);
  }
}
